import api from '../services/api';

const base = '/spiritual';

export async function fetchSpiritualFeed() {
  const { data } = await api.get(`${base}/feed/today`);
  return data;
}

export async function searchBible(q) {
  const { data } = await api.get(`${base}/bible/search`, { params: { q } });
  return data;
}

export async function adminBibleStats() {
  const { data } = await api.get(`${base}/admin/bible/stats`);
  return data;
}

export async function listBibleBooks() {
  const { data } = await api.get(`${base}/bible/books`);
  return data;
}

export async function getBibleChapter(bookCode, chapter, opts = {}) {
  const { data } = await api.get(`${base}/bible/${bookCode}/${chapter}`, {
    params: opts.log === false ? { log: 0 } : undefined,
  });
  return data;
}

export async function toggleFavorite(verseId) {
  const { data } = await api.post(`${base}/bible/favorites/${verseId}`);
  return data;
}

export async function startDevotional(planId) {
  const { data } = await api.post(`${base}/devotionals/${planId}/start`);
  return data;
}

export async function completeDevotionalDay(planId, dayIndex) {
  const { data } = await api.post(`${base}/devotionals/${planId}/complete`, { day_index: dayIndex });
  return data;
}

export async function openStudy(studyId) {
  const { data } = await api.get(`${base}/studies/${studyId}`);
  return data;
}

export async function registerEvent(eventId) {
  const { data } = await api.post(`${base}/events/${eventId}/register`);
  return data;
}

export async function attendEvent(eventId) {
  const { data } = await api.post(`${base}/events/${eventId}/attend`);
  return data;
}

// Admin
export async function adminListVerses() {
  const { data } = await api.get(`${base}/admin/verse-of-day`);
  return data;
}

export async function adminSaveVerse(body) {
  const { data } = await api.post(`${base}/admin/verse-of-day`, body);
  return data;
}

export async function adminListDevotionals() {
  const { data } = await api.get(`${base}/admin/devotionals`);
  return data;
}

export async function adminSaveDevotional(body) {
  const { data } = await api.post(`${base}/admin/devotionals`, body);
  return data;
}

export async function adminListStudies() {
  const { data } = await api.get(`${base}/admin/studies`);
  return data;
}

export async function adminSaveStudy(body) {
  const { data } = await api.post(`${base}/admin/studies`, body);
  return data;
}

export async function adminUploadStudy(file) {
  const fd = new FormData();
  fd.append('file', file);
  const { data } = await api.post(`${base}/admin/studies/upload`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function adminSaveCategory(name) {
  const { data } = await api.post(`${base}/admin/categories`, { name });
  return data;
}

export async function adminSaveAuthor(name) {
  const { data } = await api.post(`${base}/admin/authors`, { name });
  return data;
}

export async function adminListEvents() {
  const { data } = await api.get(`${base}/admin/events`);
  return data;
}

export async function adminSaveEvent(body) {
  const { data } = await api.post(`${base}/admin/events`, body);
  return data;
}

export async function adminImportBible(file, versionCode = 'RVR1960') {
  const fd = new FormData();
  fd.append('file', file);
  fd.append('version_code', versionCode);
  const { data } = await api.post(`${base}/admin/bible/import`, fd, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
}

export async function adminAiStatus() {
  const { data } = await api.get(`${base}/admin/ai/status`);
  return data;
}

export async function adminNicolasTrainer() {
  const { data } = await api.get(`${base}/admin/trainers/nicolas-del-rio`);
  return data;
}

export async function adminAiGenerateVerse(body = {}) {
  const { data } = await api.post(`${base}/admin/ai/verse-of-day`, body);
  return data;
}

export async function adminAiGenerateDevotional(body = {}) {
  const { data } = await api.post(`${base}/admin/ai/devotional`, body);
  return data;
}

export async function adminAiGenerateStudy(body = {}) {
  const { data } = await api.post(`${base}/admin/ai/study`, body);
  return data;
}

export function spiritualWidgetsEnabled() {
  return String(import.meta.env.VITE_SPIRITUAL_WIDGETS ?? 'true').toLowerCase() !== 'false';
}

const VIENTO_RECIO_ANCHOR_EMAILS = new Set([
  'nicolasdelrio718@gmail.com',
  'nicolasdelrio@foodplan.local',
]);

/** Viento Recio: super admin, flag module_access, herencia coach/gym, o coach ancla Nicolas. */
export function canShowSpiritualForUser(user) {
  if (!spiritualWidgetsEnabled() || !user) return false;
  const ma = user.module_access || {};
  const roles = Array.isArray(user.roles) && user.roles.length ? user.roles : [user.rol];
  if (roles.includes('super_admin')) return true;
  if (roles.includes('admin_d28d') && !roles.includes('super_admin')) return false;
  if (ma.spiritual === true) return true;
  if (user.coach_branding?.spiritual_enabled === true) return true;
  if (ma.spiritual === false) return false;
  const mail = String(user.email || '').trim().toLowerCase();
  if (roles.includes('entrenador') && VIENTO_RECIO_ANCHOR_EMAILS.has(mail)) return true;
  return false;
}

export async function fetchSpiritualModuleStatus() {
  const { data } = await api.get('/spiritual-module/status');
  return data?.data || data;
}

export async function fetchCoachPinnedMedia() {
  const { data } = await api.get(`${base}/coach/pinned-media`);
  return data;
}

export async function fetchCoachTodaySchedule() {
  const { data } = await api.get(`${base}/coach/today-schedule`);
  return data;
}

export async function fetchCoachTodayCatalog() {
  const { data } = await api.get(`${base}/coach/today-catalog`);
  return data;
}

export async function saveCoachTodayDay(date, body) {
  const { data } = await api.put(`${base}/coach/today-schedule/${date}`, body);
  return data;
}

export async function saveCoachDailySettings(body) {
  const { data } = await api.put(`${base}/coach/daily-settings`, body);
  return data;
}

export async function saveCoachPinnedMedia(kind, body) {
  const { data } = await api.put(`${base}/coach/pinned-media/${kind}`, body);
  return data;
}

export async function fetchSpiritualExperiences() {
  const { data } = await api.get(`${base}/experiences`);
  return data;
}

export async function postSpiritualExperience(body) {
  const { data } = await api.post(`${base}/experiences`, { body });
  return data;
}

export async function fetchSpiritualMeetings() {
  const { data } = await api.get(`${base}/events`);
  return data;
}

export async function fetchCoachMeetings() {
  const { data } = await api.get(`${base}/coach/meetings`);
  return data;
}

export async function saveCoachMeeting(body) {
  const { data } = await api.post(`${base}/coach/meetings`, body);
  return data;
}

export async function registerSpiritualMeeting(eventId) {
  const { data } = await api.post(`${base}/events/${eventId}/register`);
  return data;
}

export async function attendSpiritualMeeting(eventId) {
  const { data } = await api.post(`${base}/events/${eventId}/attend`);
  return data;
}

export async function downloadMeetingAttendanceCsv(eventId) {
  const { data } = await api.get(`${base}/coach/meetings/${eventId}/attendance.csv`, { responseType: 'blob' });
  const url = URL.createObjectURL(data);
  const a = document.createElement('a');
  a.href = url;
  a.download = `reunion-${eventId}-asistencia.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

/** El entrenador configura videos, oración y mensaje anclado de Experiencias; super_admin solo prende/apaga el flag del coach. */
export function canConfigureSpiritualContent(user) {
  if (!spiritualWidgetsEnabled() || !user) return false;
  const roles = Array.isArray(user.roles) && user.roles.length ? user.roles : [user.rol];
  if (roles.includes('super_admin')) return false;
  if (!roles.includes('entrenador')) return false;
  return user.coach_branding?.spiritual_enabled === true;
}
